import { render, staticRenderFns } from "./list-dropdown-item.component.vue?vue&type=template&id=229840ae&scoped=true"
import script from "./list-dropdown-item.component.vue?vue&type=script&lang=js"
export * from "./list-dropdown-item.component.vue?vue&type=script&lang=js"
import style0 from "./list-dropdown-item.component.vue?vue&type=style&index=0&id=229840ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229840ae",
  null
  
)

export default component.exports